import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconSpacePrivateSvg } from "./IconSpacePrivateSvg.mjs";
const IconSpacePrivate = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconSpacePrivateSvg, ...iconProps });
};
export {
  IconSpacePrivate
};
